import { pipe } from 'lib/util'
import { modelComposition } from 'trait/composition'

const descriptor = 'model::equipmentInformation'

export default pipe(
  modelComposition(descriptor),
)
